// extracted by mini-css-extract-plugin
export default {"container":"snapper_container__FMAx-","btns_section":"snapper_btns_section__lzED1","video":"snapper_video__JpgaP"};